/**
 * eKYB 商户入网系统权限
 * 已登录即可访问公司管理相关路由
 */
export default function access(initialState: { currentUser?: API.CurrentUser | undefined }) {
  const { currentUser } = initialState || {};

  if (currentUser && (currentUser as any).forbidden) {
    return {
      canAccess: false,
    };
  }

  // 已登录用户可访问 eKYB 相关路由
  return {
    canAccess: () => !!currentUser,
  };
}
